import defineComponent from 'flight';
import WithAjax from 'static/script/app/data/with-ajax';

function BetaSignupService() {

    this._optin = function (evt, payload) {
        this._post({
            url: '/beta-optin/',
            data: payload,
            success: 'data:beta-signup:after-submit',
            error: 'data:beta-signup:on-submit-error'
        });
    };

    this._optout = function (evt, payload) {
        this._post({
            url: '/beta-optout/',
            data: payload,
            success: 'data:beta-optout:after-submit',
            error: 'data:beta-optout:on-submit-error'
        });
    };

    this.after('initialize', function () {
        this.on(document, 'data:beta-signup:submit', this._optin);
        this.on(document, 'data:beta-optout:submit', this._optout);
    });
}

export default defineComponent.component(BetaSignupService, WithAjax);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/data/beta-signup-service.js